export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolTeasing: number = 10;
    public static readonly SymbolExtendedTeasing: number = null;
    public static readonly SymbolWild: number = 10;
    public static readonly SymbolsImpact: Array<number> = [7];
    public static readonly SymbolsNoTrim: Array<number> = [];
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/